import { FC } from "react";
import { useLanguage } from "../../context/LanguageContext";
import Logo from "../../assets/outcomes.svg";
import { PageHeading } from "../../compositions/PageHeading";
import Video from "../../components/Video";
import styles from "./index.module.css";

const pluginValues =
  "Source: guru-app-team/guru-outcomes-plugin\n\nGit ref: main\n\nSparse paths:\n.agents/plugins\nplugins\n";

type PluginCodePanelProps = {
  copyLabel: string;
  value: string;
};

const PluginCodePanel: FC<PluginCodePanelProps> = ({ copyLabel, value }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(value);
  };

  return (
    <div className={styles.codePanel}>
      <mui-card class={styles.codeCard} style={{ overflowX: "auto" }}>
        <mui-card-body condensed class={styles.codeCardBody}>
          <mui-button class={styles.copyButton} variant="tertiary" size="x-small" onClick={handleCopy}>
            {copyLabel}
          </mui-button>
          <pre className={styles.code}>
            <code>{value}</code>
          </pre>
        </mui-card-body>
      </mui-card>
    </div>
  );
};

export const Outcomes: FC<{}> = () => {
  const { t } = useLanguage();

  return (
    <div className="landing-page_outer">
      <div className="landing-page_inner">
        <mui-grid class={styles.grid}>
          <mui-v-stack space="var(--space-500)">
            <PageHeading page={t("outcomes.title")} logo={Logo}>
              <mui-badge variant="positive">{t("web-app.title")}</mui-badge>
            </PageHeading>
            <mui-body size="large">{t("outcomes.description")}</mui-body>
          </mui-v-stack>
          <mui-h-stack space="var(--space-300)">
            <mui-link href="#codex-plugin" variant="secondary">
              {t("outcomes.banner.secondary")}
            </mui-link>
            <mui-link href="https://outcomes.gurusuite.xyz/" target="_blank" variant="primary">
              {t("outcomes.banner.primary")}
            </mui-link>
          </mui-h-stack>
        </mui-grid>
        <Video videoId="FNtUotRRLcc?si=KqiUT8dTwY7nqOAb" />
        <mui-v-stack id="codex-plugin" class={styles.plugin} space="var(--space-500)">
          <mui-v-stack space="var(--space-200)">
            <mui-heading level="2" size="3">
              {t("outcomes.plugin.title")}
            </mui-heading>
            <mui-body>{t("outcomes.plugin.description")}</mui-body>
          </mui-v-stack>

          <mui-rule direction="horizontal" length="100%" style={{ opacity: 0.5 }}></mui-rule>

          <mui-grid class={styles.installGrid}>
            <mui-list as="ol">
              <mui-list-item>{t("outcomes.plugin.steps.item-1")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-2")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-3")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-4")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-5")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-6")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-7")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-8")}</mui-list-item>
              <mui-list-item>{t("outcomes.plugin.steps.item-9")}</mui-list-item>
            </mui-list>

            <PluginCodePanel copyLabel={t("outcomes.plugin.actions.copy")} value={pluginValues} />
          </mui-grid>
        </mui-v-stack>
      </div>
    </div>
  );
};

export default Outcomes;
